import { Expense, ExpenseKindEnum, ExpenseStatusEnum } from "@finway-group/shared/lib/models"
import { CreditCardSection } from "Components/creditCard/CreditCardSection"
import React from "react"
import { useTranslation } from "react-i18next"
import { useCardByExpense } from "Shared/hooks/creditCard.hooks"

interface ExpenseCreditCardSectionInterface {
    expense: Expense
}

export const ExpenseCreditCardSection = ({ expense }: ExpenseCreditCardSectionInterface) => {
    const { t } = useTranslation()
    const { card, isLoadingCard } = useCardByExpense(expense)

    const createInfoAlertMessage = () => {
        if (expense.status !== ExpenseStatusEnum.PURCHASE_PENDING) {
            return undefined
        }
        return expense.kind === ExpenseKindEnum.ONE_TIME_EXPENSE ? t("info:cards.one_time_card_creation_on_approval") : t("info:cards.subscription_card_creation_on_approval")
    }

    return (
        <CreditCardSection
            card={card}
            isCardLoading={isLoadingCard}
            cardId={expense.card}
            requestedBy={expense.requestedBy}
            currency={expense.currency}
            infoAlertMessage={createInfoAlertMessage()}
        />
    )
}
